import React from 'react';

import Page from 'components/page/page.component';

import './style.css';

import SignIn from './sign-in.view';
import SignUp from './sign-up.view';
import Logout from './logout.view';

const Account = () => {
    return (
        <Page className="account" heroTitle="Account" heroSize="small" variant="no-flex">
            Account Details
        </Page>
    );
};

export { Logout, SignIn, SignUp };
export default Account;
